import { render } from "./BodyViewCliente.vue?vue&type=template&id=fa0bf506"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__